import React, { FC } from 'react'
import { BetterSelect } from '../../../components/better-select/better-select'
import { ValueEditorProps } from './types'
import { getPathEntityId } from '@pushly/aqe/lib/utils/get-path-entity-id'
import { useService } from '@pushly/aqe/lib/hooks'
import { AppState } from '../../../stores/app'
import { SelectFilterBuilder } from './components/select-filter-builder'
import { OPERATORS_MAP } from './constants'
import { ArrowDownOutlined, CaretDownOutlined } from '@ant-design/icons'
import { getClassNames } from '../../../_utils/classnames'
import { Tooltip } from 'antd'

export type SelectOption = {
    value: any
    label?: string
    disabled?: boolean
    options?: SelectOption[]
}

type SelectValueEditorProps = Omit<ValueEditorProps, 'mode'> & {
    options: SelectOption[]
    selectMode?: 'multiple' | 'single'
    disableSearch?: boolean
    disableSelectAll?: boolean
    selectAllLabel?: string
    maxDisplayCount?: number
    maxDisplayFormatter?: (options: any[]) => string
}

export const DomainsFilterBuilder: FC<any> = (props) => {
    const appState = useService(AppState)

    const pathOrgId = getPathEntityId('organization')

    if (!pathOrgId) return null

    const currentUserOrgDomains =
        appState.currentUserDomains?.filter((d) => d.accountId?.toString() === pathOrgId.toString()) ?? []

    return (
        <SelectFilterBuilder
            descriptor="domain"
            onChange={props.onChange}
            value={props.value}
            operatorOptions={[OPERATORS_MAP.IN, OPERATORS_MAP.NOT_IN]}
            valueOptions={currentUserOrgDomains.map((d) => ({ value: d.id, label: d.displayName }))}
            maxDisplayValues={3}
            allSelectedDisplay="any domain"
            valueSelectProps={{
                mode: 'multiple',
                maxTagCount: 4,
                allowClear: true,
                maxTagPlaceholder: (omittedValues) => {
                    return omittedValues.length > 0 ? (
                        <Tooltip title={omittedValues.map((d) => d.title || d.label).join(', ')}>
                            {omittedValues.length} more
                        </Tooltip>
                    ) : (
                        ''
                    )
                },
                showSelectAll: true,
            }}
        />
    )
}
